<template>
  <a-card :bordered="false">
    <a-spin :spinning="spinning">
      <div class="main-panel" style="height: 840px">

        <div class="main-content-wrap">
          <div class="main-operation-wrap">
            <a-form-model :inline="true">
              <a-row :gutter="20">
                <a-col span="7">
                  <a-form-model-item label="发货地">
                    <a-select v-model="sendCity" filterable placeholder="请选择发货地" :clearable="true">
                      <a-select-option
                        v-for="item in cities"
                        :key="item.city"
                        :label="item.city"
                        :value="item.city">
                        {{ item.city }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col span="7">
                  <a-form-model-item label="日期">
                    <!--                  <a-date-picker-->
                    <!--                    v-model="time"-->
                    <!--                    type="daterange"-->
                    <!--                    value-format="yyyy-MM-dd"-->
                    <!--                    start-placeholder="开始日期"-->
                    <!--                    end-placeholder="结束日期"-->
                    <!--                    :default-time="['00:00:00', '23:59:59']">-->
                    <!--                  </a-date-picker>-->
                    <a-range-picker
                      style="width: 100%"
                      :show-time="{ format: 'HH:mm:ss' }"
                      format="YYYY-MM-DD HH:mm:ss"
                      :placeholder="['Start Time', 'End Time']"
                      v-model="time"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col span="7">
                  <a-form-model-item label="仓库">
                    <a-select v-model="warehouseNo" filterable placeholder="请选择仓库" :clearable="true">
                      <a-select-option
                        v-for="item in tableData"
                        :key="item"
                        :label="item"
                        :value="item">
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col span="3">
                  <a-form-model-item label=" ">
                    <a-button type="primary" icon="el-icon-download" @click="exportExcel">导出EXCEL
                    </a-button>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
          <div style="padding: 20px 20px">
            <a-row :gutter="20" type="flex">
              <a-col :span="12">
                <div class="info-wrap" style="">
                  <div class="info-title">在途行数统计</div>
                  <div class="info-content">
                    <simple-chart :option="orderTop10Chart.option"
                                  style="width: 100%;height: 300px"></simple-chart>
                  </div>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="info-wrap" style="">
                  <div class="info-title">预警触发条件统计</div>
                  <div class="info-content">
                    <simple-chart :option="warning.option"
                                  style="width: 100%;height: 300px"></simple-chart>
                  </div>
                </div>
              </a-col>
            </a-row>
            <a-row :gutter="20" style="margin-top: 30px">
              <a-col :span="12">
                <div class="info-wrap" style="">
                  <div class="info-title">物流统计</div>
                  <div class="info-content">
                    <simple-chart :option="logisticChart.option"
                                  style="width: 100%;height: 280px;margin-top: 20px"></simple-chart>
                  </div>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="info-wrap" style="">
                  <div class="info-title">订单年度统计</div>
                  <div class="info-content">
                    <simple-chart :option="order.option"
                                  style="width:100%;height: 300px"></simple-chart>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </a-spin>
  </a-card>
</template>

<script>

// eslint-disable-next-line import/extensions
import SimpleChart from '../components/SimpleChart';
import chinaMapData from '../assets/china.json';
// eslint-disable-next-line import/order
const echarts = require('echarts');

// 注册中国地图
echarts.registerMap('china', chinaMapData);
import {
  getYearOrders, getSendCount,

  getHome,
} from '../api/home';
import {
  getWarehousenoList, getCity,
} from '../api/order';
import {
  getWarningList,
  cancelWarning,
} from '../api/report';
import {getTime} from '../utils/dateUtil';
import {
  transportTypeFormat,
} from '../utils/formatConvert';
import {
  getWarnReasonList,
} from '../api/warnReson';
import moment from 'moment'

async function getData() {
  const sendCount = await getSendCount();
  if (sendCount.code === 1200) {
    this.orderTop10Chart.option.yAxis.data = sendCount.data.x.reverse();
    this.orderTop10Chart.option.series[0].data = sendCount.data.y.reverse();
  }
  const yearsOrder = await getYearOrders();
  if (yearsOrder.code === 1200) {
    this.order.option.xAxis.data = yearsOrder.data.x;
    this.order.option.series[0].data = yearsOrder.data.y;
  }
  const result = await getHome();
  if (result.code === 1200) {
    this.overTime = result.data.overTime;
    this.abnormal = result.data.abnormal;
    this.allOrders = result.data.allOrders;
    this.sendOrders = result.data.sendOrders;
    this.receivedOrders = result.data.receivedOrders;
    const obj = {
      name: '超时未送达',
      value: result.data.overTime,
    };
    const obj2 = {
      name: '状态异常',
      value: result.data.abnormal,
    };
    const obj3 = {
      name: '未揽收',
      value: result.data.collect,
    };
    this.logisticChart.option.series[0].data.push(obj);
    this.logisticChart.option.series[0].data.push(obj2);
    this.logisticChart.option.series[0].data.push(obj3);
  }
  const cancel = await cancelWarning();
  const warnReasonResult = await getWarnReasonList();
  const warnReasons = warnReasonResult.data || [];
  const types = warnReasons.map(x => x.reason);

  const series = types.map((x) => {
    const cancelData = cancel.data && cancel.data.value ? cancel.data.value : [];
    const reason = cancelData.filter(v => v.reason === x);
    const data = new Array(12).fill(0);
    if (reason.length > 0) {
      reason.forEach((r) => {
        data[r.month - 1] = r.count;
      });
    }
    return {
      name: x,
      type: 'line',
      symbol: 'diamond',
      symbolSize: 7,
      data,
    };
  });
  this.warning.option.series = series;
  this.warning.option.legend.data = types.map(x => ({ name: x }));
}

function currentTime() {
  const date = new Date();
  const seperator1 = '-';
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = `0${ month }`;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = `0${ strDate }`;
  }
  const currentDate = year + seperator1 + month + seperator1 + strDate;
  return currentDate;
}

async function exportExcel() {
  const timeScope = this.time && this.time.length === 2
    ? this.time : [null, null];
  this.spinning = true;
  // const loadingInstance = Loading.service({
  //   lock: true,
  //   text: 'Loading',
  //   spinner: 'el-icon-loading',
  //   background: 'rgba(0, 0, 0, 0.7)',
  // });
  let startTime = '';
  let endTime = '';
  if (this.time) {
    startTime = this.time[0];
    endTime = this.time[1];
  }
  const res = await getWarningList({
    sort: 'deliveryAt',
    direction: 'DESC',
    startAt: timeScope[0] ? moment(timeScope[0])
      .format('YYYY-MM-DD') : '',
    endAt: timeScope[1] ? moment(timeScope[1])
      .format('YYYY-MM-DD') : '',
    warehouseNo: this.warehouseNo,
    city: this.sendCity,
  });
  if (res.code === 1200) {
    const data = res.data.orders.map(x => ({
      ...x,
      orderStatusStr: x.orderStatus === 'CLOSED' ? '签收' : x.orderStatus !== 'SEND' ? '新建' : '在途',
      transportTypeStr: x.transportType === 'THIRDPART' ? '快递鸟' : 'GPS',
      // eslint-disable-next-line no-use-before-define
      agingStr: getAging(x),
      imgStatus: x.img ? '已拍照上传' : '',
    }));
    const tHeader = ['运输单号', '发货时间', 'IFS NO', 'WMS NO', 'GPS NO', '运输方式', '快递接口', '签收日期', '发货城市', '收货城市', '时效', '客户名称', '客户号', '收货地址', '订单状态', '运费', '计费重量', '制单人', '订单类型', '销售域', '销售订单号码', '回单状态'];
    const filterVal = ['orderNo', 'deliveryAt', 'ifsNo', 'wmsNo', 'gpsNo', 'expressCode', 'transportTypeStr', 'receiveAt', 'sendCity', 'receiveCity', 'agingStr', 'customerName', 'number', 'receiveAddress', 'orderStatusStr', 'freight', 'chargeableWeight', 'documentMaker', 'type', 'salesCompany', 'salesOrderNo', 'imgStatus'];
    const name = '订单信息';
    this.exportData(data, tHeader, filterVal, name);
  }
  this.spinning = false;
}

function getAging(x) {
  let date = null;
  if (x.deliveryAt !== null) {
    date = x.deliveryAt;
  } else {
    date = x.createAt;
  }
  if (x.orderStatus === 'CLOSED') {
    const start = new Date(date);
    const end = new Date(x.receiveAt);
    const diff = 1000 * 3600;
    // eslint-disable-next-line radix
    return parseInt((end.getTime() - start.getTime()) / parseInt(diff));
  }
  if (x.aging) {
    // eslint-disable-next-line radix
    return parseInt(x.aging) * 24;
  }
}

function exportData(excelData, tHeader, filterVal, name) {
  require.ensure([], () => {
    // eslint-disable-next-line camelcase,global-require
    const { export_json_to_excel } = require('../utils/Export2Excel');
    // 上面设置Excel的表格第一行的标题
    // 上面的index、nickName、name是tableData里对象的属性
    const data = this.formatJson(filterVal, excelData);
    export_json_to_excel(tHeader, data, name + getTime());
  });
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]));
}

export default {
  name: 'Home',
  components: { SimpleChart },
  data() {
    return {
      spinning: false,
      tableData: [],
      time: [],
      sendCity: '',
      cities: [],
      warehouseNo: '',
      statusData: [6, 6, 9, 13, 15, 16, 17, 18, 19, 16, 12, 8],
      isFullScreen: false,
      orderTop10Chart: {
        option: {
          toolbox: { // 可视化的工具箱
            show: true,
            right: '20px',
          },
          color: ['#4a5ca5'],
          grid: {
            top: '3%',
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          xAxis: {
            show: false,
            type: 'value',
            boundaryGap: [0, 0.01],
          },
          yAxis: {
            axisLabel: {
              color: '#324774',
            },
            axisTick: {
              show: false,
            },
            type: 'category',
            data: [],
          },
          series: [
            {
              type: 'bar',
              data: [],
              barWidth: 8,
              label: {
                show: true,
                position: 'right',
                offset: [5, 1],
              },
            },
          ],
        },
      },
      logisticChart: {
        option: {
          color: ['#4a5ca5', '#f1873e','#bbf144'],
          legend: {
            data: ['超时未送达', '状态异常','未揽收'],
            textStyle: {
              color: '#2a96fe',
              fontStyle: 'normal',
            },
            itemHeight: 20, // 高
          },
          series: [
            {
              type: 'pie',
              radius: '60%', // 设置饼图大小
              label: {
                formatter: '{b} : {c}',
              },
              data: [],
            },
          ],
        },
      },
      warning: {
        option: {
          toolbox: { // 可视化的工具箱
            show: true,
            right: '20px',
          },
          color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
          grid: {
            x: 70,
            y: 15,
            x2: 70,
            y2: 80,
            borderWidth: 10,
          },
          legend: {
            type: 'scroll',
            // itemHeight: 8,
            // itemWidth: 8,
            data: [],
            y: 'bottom',
            // padding: [0, 0, 24, 0],
          },
          tooltip: {
            trigger: 'axis',
            position: ['50%', '30%'],
            axisPointer: {
              type: 'line',
            },
            textStyle: {
              align: 'left',
            },
          },
          xAxis: [
            {
              type: 'category',
              data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
              show: true,
              axisLine: { show: false },
              axisTick: { show: false },
            },
          ],
          yAxis: [
            {
              type: 'value',
              show: true,
              axisLine: { show: false },
              axisTick: { show: false },
            },
          ],
          series: [],
        },
      },
      order: {
        option: {
          toolbox: { // 可视化的工具箱
            show: true,
            right: '20px',
          },
          color: ['#14c1fb'],
          grid: {
            top: '8%',
            left: '5%',
            right: '2%',
            bottom: '10%',
          },
          xAxis: {
            type: 'category',
            data: [],
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: '#7285af',
            },
          },
          yAxis: {
            show: true,
            type: 'value',
          },
          series: [
            {
              type: 'bar',
              data: [],
              label: {
                show: true,
                position: 'top',
                formatter: '{c}',
              },
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      { offset: 0, color: 'rgba(114,133,175,0.8)' },
                      { offset: 0.2, color: 'rgba(114,133,175,0.5)' },
                      { offset: 1, color: 'rgba(20,200,212,0)' },
                    ],
                  ),
                },
              },
              barWidth: 10,
            },
          ],
        },
      },
    };
  },
  methods: {
    currentTime,
    getData,
    exportExcel,
    exportData,
    formatJson,
    getAging,
  },
  async created() {
    const res = await getWarehousenoList();
    this.tableData = res.data.BizOrder;
    const result = await getCity();
    if (result.code === 1200) {
      this.cities = result.data.sendCity;
    }
    this.getData();
  },
};
</script>

<style scoped>
  .home {
    width: 100%;
    background-size: 100% auto;
  }

  .home-main {
    position: relative;
    margin-top: -20px;
  }

  .home-header {
    cursor: pointer;
    text-align: center;
    color: #ACB6E5;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    background: -webkit-linear-gradient(90deg, #2a7aea, #ffffff);
    font-weight: 700;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .order-num-wrap {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px;
  }

  .order-num-title {
    color: #a0dcfd;
    height: 50px;
    line-height: 50px;
  }

  .order-num-tag {
    display: inline-block;
    width: 55px;
    height: 70px;
    font-size: 40px;
    font-weight: 700;
    line-height: 70px;
    background: #007dc5;
    color: #ffffff;
    text-align: center;
    margin-right: 5px;
  }

  .order-status-wrap {
    position: absolute;
    left: 400px;
    top: 50px;
  }

  .order-status-tag {
    background: #00244f;
    width: 140px;
    display: inline-block;
    text-align: center;
    padding: 10px;
    margin-left: 10px;
  }

  .order-status {
    font-size: 30px;
  }

  .order-status-title {
    color: #9ed9fa;
  }

  .info-wrap {
    border: 1px solid #324774;
  }

  .info-content-split {
    background: url("../assets/home/split.png") no-repeat top;
    height: 5px;
    background-size: 100% auto;
    margin: 5px 30px;
  }

  .info-title {
    background-size: 100% auto;
    text-align: center;
    color: #ffffff;
    margin-top: -20px;
    font-size: 16px;
    height: 40px;
    line-height: 41px;
    background: url("../assets/home/info_title_bg.png") no-repeat top;
  }

  .info-overtime {
    background: url("../assets/home/overtime.png") no-repeat top;
    height: 70px;
    color: #B8CEDA;
    font-size: 14px;
  }

  .info-retention {
    background: url("../assets/home/retention.png") no-repeat top;
    height: 70px;
    color: #B8CEDA;
    font-size: 14px;
  }

  .info-error {
    background: url("../assets/home/error.png") no-repeat top;
    height: 70px;
    color: #B8CEDA;
    font-size: 14px;
  }

  .info-overtime .title, .info-retention .title, .info-error .title {
    margin-left: 120px;
    color: #B8CEDA;
    font-size: 14px;
    line-height: 40px;
  }

  .info-overtime .detail span {
    color: #1AEDDA;
    font-size: 38px;
  }

  .info-retention .detail span {
    color: #F1873E;
    font-size: 38px;
  }

  .info-error .detail span {
    color: #2A96FE;
    font-size: 38px;
  }

  .info-overtime .detail, .info-retention .detail, .info-error .detail {
    color: #B8CEDA;
    font-size: 14px;
    line-height: 4px;
    text-align: right;
    margin-right: 80px;
  }


</style>
